import { Layout, Button, Input, message, Table, ConfigProvider, Tabs,Row, Col, Popconfirm, Statistic, Pagination,Radio} from 'antd';
import { Content } from 'antd/lib/layout/layout';
import zhCN from 'antd/lib/locale/zh_CN';
import OAMSider from '../oam-sider';
import React, {useEffect, useRef, useState} from "react";
import {sendHttpPostRequest} from "../../../api/http-request";
import Cookies from 'js-cookie';
import idataCourseTableStyles from "../../common/global-styles/idatacourse-table.module.less";
import GlobalCss from '@/global.module.less'
import PublicTipModal from '@/component/PublicTipModal/PublicTipModal'
import { BACKEND_API_URL } from '../../../constants/constants'

const { Search } = Input;


export interface Props {}
const relatedModuleMap = new Map([[1, '课程'], [2, '实验'], [3, '题库'],[4, '知识点'], [5, 'AI问学']]);
const targetRolesMap = new Map([[1, '学生'], [2, '教师'], [3, '全部']]);
const statusMap = new Map([[1,'已上线'],[2,"未上线"]]);

export const OAMTemplateQuestionList: React.FC<Props> = (props) => {
    const [questionResult, setQuestionResult] = useState([] as any[]);  // 当前显示的结果页
    const [resultSum, setResultSum] = useState(0);  // 搜索返回的结果数
    const [totalCount, setTotalCount] = useState(0);  // 搜索返回的结果数
    const queryContent = useRef('');  // 记录搜索串
    const order = useRef('');  // 排序升序降序
    const order_by = useRef('');  // 排序列
    const page = useRef(1);  // 记录当前的页数
    const pageSize = useRef(10);  // 记录当前每页展示数量
    const relatedModuleFilters = useRef([1,2,3,4,5]);  // 相关模块
    const targetRolesFilters = useRef([1,2,3]);  // 面向对象过滤选项
    const statusFilters = useRef([1,2]);  //状态


    const [onlineCount, setOnlineCount] = useState(0) //搜索返回的结果数


  const [questionRole, setQuestionRole] = useState(3) // 新建模板问题面向对象
  const [questionModule, setQuestionModule] = useState(5) // 新建模板问题对应模块

  const newName = useRef('') // 名称
  const [createModalVis, setCreateModalVis] = useState(false)
  const createOk = () => {
    const sessionid = Cookies.get('sessionid')
    let data = {
      question: newName.current,
      relate_module: questionModule, //TODO
      target_role:questionRole, // TODO
      sessionid: sessionid,
      sid: sessionid,
    }
    sendHttpPostRequest('ai_chat/api/oam_create_template_question', data, (res) => {
      if (res.code == 0) {
        message.success('新建模板问题成功~')
        setCreateModalVis(false)
        queryTemplateQuestionList()
      } else {
        message.error(res.message)
      }
    })
    newName.current = ''
    
  }

  const createCancel = () => {
    setCreateModalVis(false)
    newName.current = ''
  }

   // 创建时面向对象改变
   const onNewTargetRoleChange = (e: any) => {
    const newRole = e.target.value
    setQuestionRole(parseInt(newRole))
  }

   // 创建时 相关模块 改变
   const onNewQuestionModuleChange = (e: any) => {
    setQuestionModule(parseInt(e.target.value))
  }


    useEffect(() => {
        queryTemplateQuestionList();
    }, [])

    /**
     * 查询模板问题列表
     */
    const queryTemplateQuestionList = () => {
        sendHttpPostRequest(
            'ai_chat/api/oam_query_template_question_list',
            {
                sessionid: Cookies.get("sessionid"),
                query: queryContent.current,
                page: page.current,
                pagesize: pageSize.current, 
                order: order.current,
                order_by: order_by.current,
                relate_modules: JSON.stringify(relatedModuleFilters.current),
                target_roles: JSON.stringify(targetRolesFilters.current),
                status:JSON.stringify(statusFilters.current),
            },
            (response: any) => {
                message.destroy();
                if (response.code == -100) {
                    // 未登录
                    window.location.href = '/oam_login?next=oam_template_question_list';
                } else if (response.code == 0) {
                    // 成功
                    setQuestionResult(response.data.list);
                    setResultSum(response.data.page_info.total_count);
                    setTotalCount(response.data.count_all);//TODO
                    setOnlineCount(response.data.count_online);//TODO
                } else if (response.code == -501) {
                    // 权限不足
                    window.location.href = '/oam_login?next=oam_template_question_list';
                } else {
                    message.error(response.message);
                }
            }
        )
    }




    //页码和页数发生了变化
    const onPageChange = (newPage: number, newPageSize?: number | undefined) => {
        page.current = newPage ? newPage : 1;
        if (newPageSize) {
            pageSize.current = newPageSize;
        }
        queryTemplateQuestionList();
    }

    // 渲染 相关模块 
    const renderRelatedModule = (text: any, record: any) => (
        <div>{relatedModuleMap.get(parseInt(text))}</div>
    )

    // 渲染目标程度
    const renderTargetRole = (text: any, record: any) => (
        <div>{targetRolesMap.get(parseInt(text))}</div>
    )

    // 渲染状态
    const renderStatus = (text: any, record: any) => (
        <div>{statusMap.get(parseInt(text))}</div>
    )


    // 点击 删除
    const onDeleteBtnClick = (questionId: string) => {
        sendHttpPostRequest(
            'ai_chat/api/oam_delete_template_question',
            {
                sessionid: Cookies.get("sessionid"),
                question_id: questionId
            },
            (response: any) => {
                message.destroy();
                if (response.code == -100) {
                    // 没登录
                    window.location.href = '/oam_login?next=oam_template_question_list';
                } else if (response.code == -501) {
                    // 没权限
                    window.location.href = '/oam_login?next=oam_template_question_list';
                } else if (response.code == 0) {
                    //message.success(response.message);
                    queryTemplateQuestionList();
                } else {
                    message.error(response.message);
                }
            }
        )
    }

    // 上下架回调
    const onPutOnOffBtnClickCallback = (response: any) => {
        message.destroy();
        if (response.code == -100) {
            // 没登录
            window.location.href = '/oam_login?next=oam_template_question_list';
        } else if (response.code == -501) {
            // 没权限
            window.location.href = '/oam_login?next=oam_template_question_list';
        } else if (response.code == 0) {
            //message.success(response.message);
            queryTemplateQuestionList();
        } else {
            message.error(response.message);
        }
    }

    // 点了上下线按钮
    const onPutOnOffBtnClick = (questionId:string, status:number) => {
        sendHttpPostRequest(
            'ai_chat/api/oam_set_template_question_status',
            {
                sessionid: Cookies.get("sessionid"),
                question_id: questionId,
                status: status == 1? 2:1
            },
            onPutOnOffBtnClickCallback
        )
    }



    // 渲染操作
    const renderActions = (text:any, record:any) => {
   
            return (
                <Row justify="center" align="middle" gutter={[8, 4]} wrap={false} >
                    <Col style={{width:50}}>
                        <Button
                            style={{borderRadius:20,fontSize:14}}
                            size='small'
                            id="editit"
                            type="dashed"
                            onClick={onEditBtnClick.bind(this,record.id)} > 编辑
                        </Button>
                    </Col>
                    {<Col style={{width:50}}> { parseInt(record.status) == 2 ?
                        <Button style={{borderRadius:20,fontSize:12}} size='small' id="puton" value={record.id} type="primary"  onClick={onPutOnOffBtnClick.bind(this, record.question_id, record.status)}> 上 线 </Button>
                        :  <Popconfirm placement="top" title={'确认下线模板问题"' + record.question + '"吗？'} onConfirm={onPutOnOffBtnClick.bind(this, record.question_id, record.status)} okText="确认" cancelText="取消">
                            <Button style={{borderRadius:20,fontSize:12}} size='small' id="putoff" value={record.id} type="primary" danger> 下 线 </Button>
                        </Popconfirm>}
                    </Col> }
                    <Col style={{width:50}}>
                        {parseInt(record.status) == 2 ?
                            <Popconfirm placement="top" title={'确认删除模板问题"' + record.question + '"吗？'} onConfirm={onDeleteBtnClick.bind(this, record.question_id)} okText="确认" cancelText="取消">
                                <Button
                                    style={{borderRadius:20,fontSize:14}}
                                    size='small'
                                    id="deleteexe"
                                    type="dashed"
                                    danger
                                > 删除
                                </Button>
                            </Popconfirm>
                            :
                            <Button
                            style={{borderRadius:20,fontSize:14}}
                            size='small'
                            id="deleteexe"
                            type="dashed"
                            danger
                            disabled={true}
                            > 删除
                            </Button>
                        }
                    </Col>
                </Row>
            )
         
    }

    //点击了编辑按钮
    const onEditBtnClick = (id:any,  event:any) => {
       message.success("功能待实现")
    }

    //点击了搜索按钮
    const onSearchBtn = (value: string) => {
        page.current = 1;
        queryContent.current = value;
        queryTemplateQuestionList();
    }



    // 表格发生变化
    const onTableChange:any = (pagination:any, filters:any, sorter:any, extra: { currentDataSource: [], action: any })=> {
        if (sorter.order) { //如果选择了排序列
            order.current = sorter.order;
            order_by.current = sorter.field;
        }
        if (filters.relate_module) { //如果选择了过滤列
            relatedModuleFilters.current = filters.relate_module;
        } else {
            relatedModuleFilters.current = [1,2,3,4,5];
        }
        if (filters.target_role) {
            targetRolesFilters.current = filters.target_role;
        } else {
            targetRolesFilters.current = [1,2,3];
        }
        if (filters.status) {
            statusFilters.current = filters.status;
        } else {
            statusFilters.current = [1,2];
        }
        page.current = 1;
        queryTemplateQuestionList();
    }

    const columns:any = [
          {
            title: 'ID',
            dataIndex: 'question_id',
            key: 'question_id',
            align: 'left',
            width: 80,
            ellipsis: true,
            
          },
          {
            title: '名称',
            dataIndex: 'question',
            key: 'question',
            ellipsis: true,
            align: 'left',
            width: 150,
          },
          {
            title: '创建者',
            dataIndex: 'real_name',
            key: 'real_name',
            align: 'left',  
            ellipsis: true,        
            width: 100,
            render: (t, r, i) => {
                return (
                <Row align="middle" wrap={false} justify="start" style={{ gap: '5px' }}>
                    <Col>
                    <img
                        className={GlobalCss.avatar}
                        src={BACKEND_API_URL + r.avatar}
                        alt=""
                    />
                    </Col>
                    <Col>{t?t:r.name}</Col>
                </Row>
                )
            },
          },
          {
            title: '创建时间',
            dataIndex: 'create_time',
            key: 'create_time',
            align: 'center',
            width: 120,
            sorter: true,
            ellipsis: true,
            sortDirections: ['descend', 'ascend'],
          },
          {
            title: '相关模块',
            dataIndex: 'relate_module',
            key: 'relate_module',
            align: 'center',
            width: 80,
            ellipsis: true,
            render: renderRelatedModule,
            filters: [
                {
                    text: 'AI问学',
                    value: 5,
                },
                {
                    text: '课程',
                    value: 1,
                },
                {
                    text: '实验',
                    value: 2,
                },
                {
                    text: '题库',
                    value: 3,
                },
                {
                    text: '知识点',
                    value: 4,
                }
            ],
            onFilter: (value:any, record:any) => true,
          },
         
          {
            title: '对象',
            dataIndex: 'target_role',
            key: 'target_role',
            align: 'center',
            ellipsis: true,
            width: 80,
            render: renderTargetRole,
            filters: [
                {
                    text: '全部',
                    value: 3,
                },
                {
                    text: '学生',
                    value: 1,
                },
                {
                    text: '教师',
                    value: 2,
                }
            ],
            onFilter: (value:any, record:any) => true,
          },
          {
            title: '点击量',
            dataIndex: 'click',
            key: 'click',
            align: 'click',
            width: 80,
            sorter: true,
            ellipsis: true,
            sortDirections: ['descend', 'ascend'],
          },
          {
            title: '状态',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            width: 80,
            ellipsis: true,
            render: renderStatus,
            filters: [
                {
                    text: '未上线',
                    value: 2,
                },
                {
                    text: '已上线',
                    value: 1,
                }
            ],
            onFilter: (value:any, record:any) => true,
          },

          {
            title: "操作",
            dataIndex: "id",
            key: "actions",
            width: 220,
            ellipsis: true,
            fixed:'right',
            align: 'center',
            render: renderActions ,
        },
      ];

    return (
             
        <Layout style={{ minHeight: '100vh',minWidth:1200 }}>
            <OAMSider keys={['666']}  openKeys={['sub-ai-learn']} />
            <Layout style={{backgroundColor:'#f9f9f9'}}>
                <Content style={{ backgroundColor:'#fff',borderRadius:5,minWidth:400,margin:30 ,paddingTop:20}}>
                  <div style={{paddingLeft: 30, paddingRight: 30, paddingBottom: 30}}>
                        <Row align="middle"  gutter={16} >
                            <Col flex='160px'>
                                <Statistic title="总模板问题" value={totalCount} />
                            </Col>
                            <Col flex='80px'>
                                <Statistic title="已上线" value={onlineCount} />
                            </Col>
                            <Col flex='250px'>
                                <Search
                                    placeholder="搜索模板问题"
                                    style={{ width: 350 }}
                                    enterButton={true}
                                    onSearch={onSearchBtn}
                                    className={idataCourseTableStyles.oamSearch}
                                />
                            </Col>
                            <Col flex='auto' style={{textAlign: 'right'}}>
                                <Button type="primary" style={{float: 'right', marginRight: 20, borderRadius: 20, textShadow:'none', boxShadow:'none'}} 
                                onClick={()=>{newName.current = '';  setCreateModalVis(true)}}>
                                    创建模板问题</Button>
                            </Col>
                        </Row>
                        
                        <div style={{minHeight:480}}  className={idataCourseTableStyles.tableWrapper}>
                                <ConfigProvider locale={zhCN}>
                                    <Table
                                        dataSource={questionResult}
                                        columns={columns}
                                        rowKey={record => record.question_id}
                                        pagination={false}
                                        scroll={{ x: 800 }}
                                        onChange={onTableChange}
                                    />
                                </ConfigProvider>
                        </div>
                           
        
                        <ConfigProvider locale={zhCN}>
                            <div style={{marginBottom:30}} className={"css.pagination"} >
                                <Pagination
                                    defaultCurrent={1}
                                    total={resultSum}
                                    defaultPageSize={10}
                                    hideOnSinglePage={true}
                                    current={page.current}
                                    onChange={onPageChange}
                                    showQuickJumper={true}
                                    showSizeChanger={false}
                                    showTotal={total => `共 ${total} 模板问题`}
                                />
                            </div>
                        </ConfigProvider>
                    </div>
                </Content>


                <PublicTipModal
                    modalContent={<div>
                    <Row
                        gutter={[8, 8]}
                        justify="start"
                        align="middle"
                        style={{ marginBottom: 15 }}
                    >
                        <Col className={GlobalCss.requiredLabel}>
                        名称
                        </Col>
                        <Col flex="auto" style={{ textAlign: 'left'}}>
                        <Input
                            placeholder="请输入题目名称"
                            required={true}
                            onChange={(e) => {  newName.current = e.target.value}}
                        />
                        </Col>
                    </Row>

                    <Row
                        gutter={[8, 8]}
                        justify="start"
                        align="middle"
                        style={{ marginBottom: 10 }}
                    >
                        <Col className={GlobalCss.requiredLabel}>
                        相关模块
                        </Col>
                        <Col flex="auto" style={{ textAlign: 'left' }}>
                        <Radio.Group
                            style={{ width: 300, textAlign: 'left' }}
                            onChange={onNewQuestionModuleChange}
                            defaultValue={5}
                        >
                            <Radio value={5}>AI问学</Radio>
                            <Radio value={1}>课程</Radio>
                            <Radio value={2}>实验</Radio>
                            <Radio value={3}>题库</Radio>
                            <Radio value={4}>知识点</Radio>
                        </Radio.Group>
                        </Col>
                    </Row>

                    <Row
                        gutter={[8, 8]}
                        justify="start"
                        align="middle"
                        style={{ marginBottom: 10 }}
                    >
                        <Col className={GlobalCss.requiredLabel}>
                        对象
                        </Col>
                        <Col flex="auto" style={{ textAlign: 'left' }}>
                        <Radio.Group
                            style={{ width: 300, textAlign: 'left' }}
                            onChange={onNewTargetRoleChange}
                            defaultValue={3}
                        >
                            <Radio value={1}>学生</Radio>
                            <Radio value={2}>教师</Radio>
                            <Radio value={3}>全部</Radio>
                        </Radio.Group>
                        </Col>
                    </Row>

                    </div>
                    }
                    modalTitle={'创建模板问题'}
                    handleOk={createOk}
                    handleCancel={createCancel}
                    open={createModalVis}
                    setOpen={setCreateModalVis}
                    />
            </Layout>
            
        </Layout>

    )

}

export default OAMTemplateQuestionList

